module.exports = __webpack_public_path__ + "static/img/icon-en-2.42dfd904.png";